import { handleActions } from 'redux-actions';
import { chatFlowGetSucceeded } from './chatFlow';
// Init state for the Chat Nodes.
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
    },
    nodes: null,
};
// Reducer
const chatNodes = handleActions({
    [chatFlowGetSucceeded.toString()]: (state, action) => {
        var _a, _b;
        const nodes = {};
        if (((_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.actions) &&
            Array.isArray(action.payload.data.actions)) {
            for (const node of action.payload.data.actions) {
                nodes[node.id] = node;
            }
            return Object.assign(Object.assign({}, state), { nodes });
        }
        return state;
    },
}, initialState);
export default chatNodes;
